export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Battery Technology Professional | London',
    'I finally understand the complete picture of battery systems—from electrochemistry through management, BESS applications, and grid integration. This resource transformed how I approach energy storage professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Renewable Energy Specialist | Dublin',
    'I know exactly how to explain battery chemistry, performance characteristics, management systems, and grid applications. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Energy Storage Systems Engineer | Amsterdam',
    'The technical depth saves me countless hours. The integrated scenarios are organized step-by-step. I never struggle with technical explanations anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Battery Professional',
    "Battery chemistry and management systems completely changed how I understand energy storage. It's the clearest technical resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Energy Storage Specialist',
    'The 200 technical terms alone are worth the price. I never struggle with technical terminology anymore. Everything is organized and accessible.',
  ],
  [
    'MS',
    'Martin S.',
    'BESS Systems Engineer',
    'The 20 application scenarios and 12 industry guides were eye-opening. I can now explain battery storage applications across solar, wind, commercial, industrial, and grid sectors. This transformed my professional credibility.',
  ],
];
